import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from "primeng/select";
import { Subscription } from 'rxjs';
import { InstantBankTransferService } from '../instant-bank-transfer.service';
import { TransactionService } from '../transaction/transaction.service';
import { Action, Amount, Currency, ErrorCode, FlowCode, OrchestrationRequest, OrchestrationResponse, PartnerValidationErrorResponse, PaymentDetails } from '../general.model';
import { AuthService } from '../transaction/auth.service';
import { environment } from '../../environments/environment';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';


interface PurposeOption {
  label: string;
  value: string;
}

interface CountryOption {
  label: string;
  value: string;
  flag: string;
  currency?: string;
}

@Component({
  selector: 'app-receive-money-abroad-amount',
  standalone: true,
  imports: [ DropdownModule ,FormsModule, CommonModule, SelectModule, ButtonModule],
  templateUrl: './receive-money-abroad-amount.component.html',
  styleUrl: './receive-money-abroad-amount.component.css'
})
export class ReceiveMoneyAbroadAmountComponent implements OnInit, OnDestroy {


  selectedTab: string = 'EUR';

  data = {
    bankLocation: 'BEL',
    purpose: 'Family support',
    currency: 'EUR',
    sourceCurrency:"",
    targetCurrency:"",
    rate: 6.49,
    amount: 1,
    converted: 3245,
    time: 'Up to 24 hours',
    cost: 530
  };

  amount!:number;

  sourceCurrency = 'EUR';
  targetCurrency = 'UGX';

  exchangeRate = 6.49;

  purposeOpen = false;

  purposes: PurposeOption[] = [
    { label: 'Family support', value: 'family-support' },
    { label: 'Education', value: 'education' },
    { label: 'Medical', value: 'medical' },
    { label: 'Business', value: 'business' },
    { label: 'Other', value: 'other' }
  ];

selectedPurpose!: string | null;
isQuoteResult: boolean=false;
minAmount!: number|null;
maxAmount!: number|null;
countries: CountryOption[] = [
  {
    label: 'Austria',
    value: 'AUT',
    flag: 'fi fis fi-at',
    currency: 'EUR'
  },
  {
    label: 'Belgium',
    value: 'BEL',
    flag: 'fi fis fi-be',
    currency: 'EUR'
  },
  {
    label: 'Estonia',
    value: 'EST',
    flag: 'fi fis fi-ee',
    currency: 'EUR'
  },
  {
    label: 'Finland',
    value: 'FIN',
    flag: 'fi fis fi-fi',
    currency: 'EUR'
  }
  ,
  {
    label: 'France',
    value: 'FRA',
    flag: 'fi fis fi-fr',
    currency: 'EUR'
  },
  {
    label: 'Germany',
    value: 'DEU',
    flag: 'fi fis fi-de',
    currency: 'EUR'
  },
  {
    label: 'Ireland',
    value: 'IRL',
    flag: 'fi fis fi-ie',
    currency: 'EUR'
  },
  {
    label: 'Italy',
    value: 'ITA',
    flag: 'fi fis fi-it',
    currency: 'EUR'
  },
  {
    label: 'Latvia',
    value: 'LVA',
    flag: 'fi fis fi-lv',
    currency: 'EUR'
  },
  {
    label: 'Lithuania',
    value: 'LTU',
    flag: 'fi fis fi-lt',
    currency: 'EUR'
  },
  {
    label: 'Netherlands',
    value: 'NLD',
    flag: 'fi fis fi-nl',
    currency: 'EUR'
  },
  {
    label: 'Portugal',
    value: 'PRT',
    flag: 'fi fis fi-pt',
    currency: 'EUR'
  },
  {
    label: 'Slovakia',
    value: 'SVK',
    flag: 'fi fis fi-sk',
    currency: 'EUR'
  },
  {
    label: 'Slovenia',
    value: 'SVN',
    flag: 'fi fis fi-si',
    currency: 'EUR'
  },
  {
    label: 'Spain',
    value: 'ESP',
    flag: 'fi fis fi-es',
    currency: 'EUR'
  },
  {
    label: 'United Kingdom',
    value: 'GBR',
    flag: 'fi fis fi-gb',
    currency: 'GBP'
  }
];
selectedCountry: CountryOption = this.countries.find(c => c.value === 'BEL') || this.countries[0];
otherPurpose: any;

  constructor(private router: Router,
    protected instantBankTransferService:InstantBankTransferService,
    private transactionService:TransactionService,
    private authService: AuthService
  ) {
    this.data.sourceCurrency=this.sourceCurrency;
    this.data.targetCurrency=this.targetCurrency;

    
  }
  
  isQuoteLoading: boolean = false;
  quoteError: string | null = null;
  private amountDebounceTimer: any = null;
  private quoteSubscription?: Subscription;

  ngOnInit(): void {
    const existingDetails = this.instantBankTransferService.data();
    const savedCountry = existingDetails?.bankLocation
      ? this.countries.find(c => c.value === existingDetails.bankLocation)
      : null;

    this.selectedCountry = savedCountry || this.countries.find(c => c.value === 'BEL') || this.countries[0];
    this.selectedTab = existingDetails?.currency || this.selectedCountry?.currency || 'EUR';
    this.amount = existingDetails?.amount || 100;
    this.selectedPurpose = existingDetails?.purpose || 'family-support';
    this.syncActiveQuoteState();

    let paymentDetails: PaymentDetails = existingDetails || ({} as PaymentDetails);
    paymentDetails.amount = this.amount;
    paymentDetails.currency = this.activeQuoteCurrency;
    paymentDetails.sourceCurrency = (this.selectedCountry.currency || 'EUR') as Currency;
    paymentDetails.targetCurrency = Currency.UGX;
    paymentDetails.bankLocation = this.selectedCountry.value;
    paymentDetails.purpose = this.selectedPurpose || 'family-support';
    this.instantBankTransferService.data.set(paymentDetails);

    if (!localStorage.getItem('token') && !this.authService.diasporaSessionToken()) {
      console.log('No diaspora session token found on amount page, initiating session via /');
      this.router.navigateByUrl('/');
      return;
    }

    this.paymentQuote();
  }

  ngOnDestroy(): void {
    if (this.amountDebounceTimer) {
      clearTimeout(this.amountDebounceTimer);
    }
    this.quoteSubscription?.unsubscribe();
  }

  amountHasError: boolean = false;
  /*get amountHasError(): boolean {
    return this.amount > 0 && this.amount < 1;
  }*/

  get convertedAmount(): number {
    this.data.converted = this.amount * this.exchangeRate;
    //this.instantBankTransferService.data.set(this.data);
    return this.data.converted;
  }
  
  updateConvertedAmount(): void {
    const rate = this.fxRate?.data?.fxRate ?? this.exchangeRate ?? 0;
    const converted = this.amount ? this.amount * rate : 0;

    this.data.converted = converted; 
    
    let paymentDetails = this.instantBankTransferService.data() || {};
    paymentDetails.amount = this.amount;
    paymentDetails.converted = converted;
    paymentDetails.sourceCurrency = this.selectedCountry?.currency;
    this.instantBankTransferService.data.set(paymentDetails);

    this.checkAndLaunch();
  }

  onAmountInput(): void {
    if (this.amountDebounceTimer) {
      clearTimeout(this.amountDebounceTimer);
    }
    this.amountDebounceTimer = setTimeout(() => {
      this.updateConvertedAmount();
    }, 500);
  }

  onPurposeChange(event: any): void {
    const value = event?.value || this.selectedPurpose;
    if (!value) {
      return;
    }

    this.selectedPurpose = value;
    const paymentDetails: PaymentDetails = this.instantBankTransferService.data() || {};
    paymentDetails.purpose = value;
    this.instantBankTransferService.data.set(paymentDetails);

    this.checkAndLaunch();
  }

  onclick(event: any){
    let activationId : string="";
    console.log("event :" + this.selectedPurpose);

    if (!this.selectedPurpose) {
      //this.isPurposeSet = false;
      return;
    }
  
    //this.isPurposeSet = true;
  
    const paymentDetails: PaymentDetails =
      this.instantBankTransferService.data() || {};
  
    paymentDetails.purpose = this.selectedPurpose;
    this.instantBankTransferService.data.set(paymentDetails);
  
    this.checkAndLaunch();
  }

  onOtherPurpose(event: any){
    let activationId : string="";
    console.log("event :" + this.selectedPurpose);

    this.selectedPurpose = this.customPurpose.trim();
  
    if (!this.selectedPurpose) {
      //this.isPurposeSet = false;
      return;
    }
  
    //this.isPurposeSet = true;
  
    const paymentDetails: PaymentDetails =
      this.instantBankTransferService.data() || {};
  
    paymentDetails.purpose = this.selectedPurpose;
    this.instantBankTransferService.data.set(paymentDetails);
  
    this.checkAndLaunch();
  }


  get nextDisabled(): boolean {
    const purposeIsMissing =
      !this.selectedPurpose ||
      (this.isOtherPurposeSelected && !this.customPurpose.trim());
  
    return this.isQuoteLoading || Boolean(this.quoteError) || this.amountHasError || !this.amount || purposeIsMissing;
  }

  get activeQuoteCurrency(): Currency {
    return this.selectedTab === 'UGX'
      ? Currency.UGX
      : (this.selectedCountry?.currency as Currency || Currency.EUR);
  }

  get referenceCurrency(): number {
    const currency = this.activeQuoteCurrency;
    return currency === Currency.EUR || currency === Currency.GBP ? 0 : 1;
  }

  private syncActiveQuoteState(): void {
    const activeCurrency = this.activeQuoteCurrency;
    const targetCurrency = this.selectedTab === 'UGX'
      ? (this.selectedCountry?.currency as Currency || Currency.EUR)
      : Currency.UGX;

    this.sourceCurrency = activeCurrency;
    this.targetCurrency = targetCurrency;
    this.data.currency = activeCurrency;
    this.data.sourceCurrency = activeCurrency;
    this.data.targetCurrency = targetCurrency;
  }

  private updateCorridorLimitsForActiveCurrency(): void {
    const details = this.fxRate?.data?.limits?.corridorLimits?.currencyDetails || this.fxRate?.data?.limits?.currencyDetails;
    this.maxAmount = details?.find((c: any) => c.currency === this.activeQuoteCurrency)?.maxAmount ?? null;
    this.minAmount = details?.find((c: any) => c.currency === this.activeQuoteCurrency)?.minAmount ?? null;
  }

  selectTab(tab: string): void {
    if (this.selectedTab === tab) {
      return;
    }

    if (this.amountDebounceTimer) {
      clearTimeout(this.amountDebounceTimer);
      this.amountDebounceTimer = null;
    }

    const wasLocal = this.selectedTab === 'UGX';
    const isNowLocal = tab === 'UGX';
    const quoteData = this.fxRate?.data;
    const rate = quoteData?.fxRate || (this.exchangeRate > 100 ? this.exchangeRate : 4053.77);

    if (this.amount && this.amount > 0) {
      if (!wasLocal && isNowLocal) {
        if (quoteData?.creditedAmount && this.amount === quoteData?.sourceAmount) {
          this.amount = Number(quoteData.creditedAmount.toFixed(2));
        } else {
          this.amount = Number((this.amount * rate).toFixed(2));
        }
      } else if (wasLocal && !isNowLocal) {
        if (quoteData?.sourceAmount && this.amount === quoteData?.creditedAmount) {
          this.amount = Number(quoteData.sourceAmount.toFixed(2));
        } else {
          this.amount = Math.max(1, Number((this.amount / rate).toFixed(2)));
        }
      }
    }

    this.selectedTab = tab;
    this.syncActiveQuoteState();
    this.updateCorridorLimitsForActiveCurrency();
    this.amountHasError = false;
    this.quoteError = null;

    const paymentDetails: PaymentDetails = this.instantBankTransferService.data() || ({} as PaymentDetails);
    paymentDetails.amount = this.amount;
    paymentDetails.currency = this.activeQuoteCurrency;
    paymentDetails.sourceCurrency = (this.selectedCountry?.currency as Currency || Currency.EUR);
    paymentDetails.targetCurrency = Currency.UGX;
    this.instantBankTransferService.data.set(paymentDetails);

    this.checkAndLaunch();
  }

  togglePurpose(): void {
    this.purposeOpen = !this.purposeOpen;
  }

  customPurpose = '';
  customPurposeTouched = false;

  get isOtherPurposeSelected(): boolean {
    return this.selectedPurpose === 'other';
  }

  /*selectPurpose(purpose: PurposeOption): void {
    this.selectedPurpose = purpose;
    this.purposeOpen = false;
  
    if (purpose.value === 'other') {
      this.customPurpose = '';
      this.customPurposeTouched = false;
      this.isPurposeSet = false;
  
      const paymentDetails: PaymentDetails =
        this.instantBankTransferService.data();
  
      paymentDetails.purpose = '';
      this.instantBankTransferService.data.set(paymentDetails);
  
      return;
    }
  
    this.customPurpose = '';
    this.customPurposeTouched = false;
    this.isPurposeSet = true;
  
    const paymentDetails: PaymentDetails =
      this.instantBankTransferService.data();
  
    paymentDetails.purpose = purpose.label;
    this.instantBankTransferService.data.set(paymentDetails);
  
    this.checkAndLaunch();
  }*/

  onCustomPurposeBlur(): void {
    this.customPurposeTouched = true;
  
    const purpose = this.customPurpose.trim();
  
    if (!purpose) {
      //this.isPurposeSet = false;
      return;
    }
  
    //this.isPurposeSet = true;
  
    const paymentDetails: PaymentDetails =
      this.instantBankTransferService.data();
  
    paymentDetails.purpose = purpose;
    this.instantBankTransferService.data.set(paymentDetails);
  
    this.checkAndLaunch();
  }

  initialQuote(){
    const paymentDetails: PaymentDetails =
    this.instantBankTransferService.data();

    paymentDetails.sourceCurrency = this.selectedCountry.currency as Currency;
    paymentDetails.currency = this.selectedCountry.currency as Currency;
    paymentDetails.bankLocation = this.selectedCountry.value;
    
    this.instantBankTransferService.data.set(paymentDetails);

    const amountCurrency = this.selectedTab === 'UGX'
      ? Currency.UGX
      : (this.selectedCountry?.currency as Currency || Currency.EUR);

    let amount:Amount = {currency:amountCurrency,
          value:1};
        let orchestrationRequest:OrchestrationRequest={
            amount: amount,
            action: Action.QUOTE,
            flowCode: FlowCode.DW_BANK_TOPUP_THUNES,
            quoteId: '',
            purposeOfFunds: 'education',
            countryOfResidence: this.countries.find(c => c.value === this.selectedCountry.value)?.value || '',
            referenceCurrency: this.referenceCurrency
        };

        const correlationId: string = this.authService.uuid() ?? '';
        this.transactionService.initiateOrchestrator(correlationId,environment.partnerId,orchestrationRequest).subscribe({
          next: (response) => {
          if (!response || !response.data) {
            console.error('Invalid quote response received:', response);
            return;
          }
          this.fxRate = response;
          this.isQuoteResult = true;
          this.exchangeRate = response.data?.fxRate ?? 0;  
          this.authService.setQuoteDetails(this.fxRate);
          this.amountHasError = response.data?.limits?.result === 'SUCCESS' ? false : true;
          const details = response.data?.limits?.corridorLimits?.currencyDetails || response.data?.limits?.currencyDetails;
          this.maxAmount = details?.find((c: any) => c.currency === this.sourceCurrency)?.maxAmount ?? null;
          this.minAmount = details?.find((c: any) => c.currency === this.sourceCurrency)?.minAmount ?? null;
          console.log('Data received:', response);
        },
          error: (err) => {
            let partnerValidationErrorResponse:PartnerValidationErrorResponse=err;
            const isKnownError = Object.values(ErrorCode).includes( err.code as ErrorCode);

            if(isKnownError){
              this.router.navigateByUrl('/feature-not-available');
            } else {
              this.router.navigate(['/service-unavailable']);
            }

            console.error('Error occurred:', err);
          }
        });

  }


  private checkAndLaunch(): void {
    if (this.selectedPurpose && this.amount > 0) {
      this.amountHasError=false;
      this.paymentQuote();
    }
  }

  goNext(): void {

    this.router.navigate(['/confirm']);

    console.log({
      amount: this.amount,
      from: this.sourceCurrency,
      to: this.targetCurrency,
      convertedAmount: this.convertedAmount,
      purpose: this.selectedPurpose
    });
  }

  fxRate!: OrchestrationResponse
  
  paymentQuote(){
    if (!this.amount || this.amount <= 0) {
      return;
    }

    this.data.amount = this.amount;
    let paymentDetails:PaymentDetails = this.instantBankTransferService.data() || ({} as PaymentDetails);
    paymentDetails.amount = this.amount;
    const currency = this.activeQuoteCurrency;
    paymentDetails.currency = currency;
    paymentDetails.sourceCurrency = (this.selectedCountry?.currency as Currency || Currency.EUR);
    paymentDetails.targetCurrency = Currency.UGX;
    paymentDetails.bankLocation = this.selectedCountry?.value || paymentDetails.bankLocation || 'BEL';
    this.instantBankTransferService.data.set(paymentDetails);

    let amount:Amount = {
      currency: currency,
      value: this.amount
    };
    let orchestrationRequest:OrchestrationRequest={
        amount: amount,
        action: Action.QUOTE,
        flowCode: FlowCode.DW_BANK_TOPUP_THUNES,
        quoteId: '',
        purposeOfFunds: paymentDetails.purpose || this.selectedPurpose || 'family-support',
        countryOfResidence: this.selectedCountry?.value || 'BEL',
        referenceCurrency: this.referenceCurrency
    };

    const correlationId: string = this.authService.uuid() || localStorage.getItem('correlation-id') || crypto.randomUUID();
    this.authService.setUUID(correlationId);

    this.quoteSubscription?.unsubscribe();
    this.isQuoteLoading = true;
    this.quoteError = null;

    this.quoteSubscription = this.transactionService.initiateOrchestrator(correlationId,environment.partnerId,orchestrationRequest).subscribe({
      next: (response) => {
        this.isQuoteLoading = false;
        if (!response || !response.data) {
          console.error('Invalid quote response received:', response);
          this.quoteError = 'Received empty quote response from backend.';
          return;
        }
        this.fxRate = response;
        this.isQuoteResult = true;
        if (response.data.fxRate) {
          this.exchangeRate = response.data.fxRate;
        }
        this.authService.setQuoteDetails(this.fxRate);
        const limitsResult = this.fxRate.data?.limits?.result;
        this.amountHasError = limitsResult === 'SUCCESS' ? false : true;
        this.updateCorridorLimitsForActiveCurrency();

        const updatedDetails: PaymentDetails = this.instantBankTransferService.data() || ({} as PaymentDetails);
        updatedDetails.cost = response.data.sourceAmount ?? this.amount;
        updatedDetails.converted = response.data.creditedAmount ?? 0;
        updatedDetails.rate = response.data.fxRate ?? this.exchangeRate;
        updatedDetails.sourceCurrency = (response.data.sourceCurrency || this.selectedCountry?.currency || Currency.EUR) as Currency;
        updatedDetails.targetCurrency = (response.data.creditedCurrency || Currency.UGX) as Currency;
        updatedDetails.quoteId = response.data.quotationId || '';
        this.instantBankTransferService.data.set(updatedDetails);

        console.log('Quote data received:', response);
      },
      error: (err) => {
        this.isQuoteLoading = false;
        console.error('Quote error occurred:', err);

        const backendMsg = err?.error?.error?.message || err?.error?.message;
        if (err?.status === 401) {
          this.quoteError = 'Session token is unauthorized or expired. Please re-authenticate.';
        } else if (err?.status === 0) {
          this.quoteError = 'Network/CORS error: Request was blocked. Make sure to run with dev proxy (npm start).';
        } else {
          this.quoteError = backendMsg || err?.message || 'Quote service unavailable.';
        }

        localStorage.setItem('h5-session-diagnostics', JSON.stringify({
          stage: 'payment-quote-error',
          at: new Date().toISOString(),
          status: err?.status,
          statusText: err?.statusText,
          url: err?.url,
          message: err?.message,
          debugCause: this.quoteError,
          backendCode: err?.error?.error?.code || err?.error?.code,
          backendMessage: backendMsg
        }));
      }
    });

  }

  /**
   * Use this only to preview the error screenshot quickly.
   * You can remove it later.
   */
  showErrorState(): void {
    this.amount = 0.55;
    this.selectedPurpose = null;
  }

  showNormalState(): void {
    this.amount = 500.00;
  }

  selectedCurrency() {
    return this.selectedTab === 'UGX'
      ? 'UGX'
      : (this.selectedCountry?.currency || this.selectedTab || 'EUR');
  }

  selectCountry(country: DropdownChangeEvent): void {
      if (this.amountDebounceTimer) {
        clearTimeout(this.amountDebounceTimer);
        this.amountDebounceTimer = null;
      }

      this.selectedCountry = country.value;
      let paymentDetails:PaymentDetails = this.instantBankTransferService.data() || ({} as PaymentDetails);
      
      if (paymentDetails) {
        let countryOption:CountryOption|undefined = country.value;
        const curr = (countryOption?.currency || 'EUR') as Currency;
        this.selectedTab = this.selectedTab === 'UGX' ? 'UGX' : curr;
        this.syncActiveQuoteState();
        this.updateCorridorLimitsForActiveCurrency();

        paymentDetails.currency = this.activeQuoteCurrency;
        paymentDetails.sourceCurrency = curr;
        paymentDetails.targetCurrency = Currency.UGX;
        paymentDetails.bankLocation = countryOption?.value || 'BEL';
      }
      this.instantBankTransferService.data.set(paymentDetails);
      this.checkAndLaunch();
    }
}
